import { Link } from 'react-router-dom';

export default function Footer() {
  const handleAnchor = (hash: string) => {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-drift py-20">
      <div className="max-w-7xl mx-auto px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 mb-5 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/172799ddc18d4cdef706c1984918906a.png" 
                alt="SkySails AI" 
                className="h-24 w-auto"
              />
            </Link>
            <p className="text-sm text-navy/50 font-light leading-relaxed max-w-xs">
              Calm, intelligent systems that bring clarity and steady improvement to your operations.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[13px] font-semibold text-navy mb-5 tracking-wide uppercase">
              <a href="#" className="cursor-pointer">Navigate</a>
            </h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: 'Home', to: '/' },
                { label: 'Industries', hash: '#industries' },
                { label: 'Process', hash: '#process' },
                { label: 'About', hash: '#about' },
                { label: 'Contact', hash: '#contact' },
              ].map((item) =>
                item.hash ? (
                  <a
                    key={item.label}
                    href={item.hash}
                    onClick={(e) => {
                      e.preventDefault();
                      handleAnchor(item.hash!);
                    }}
                    className="text-sm text-navy/50 hover:text-anchor transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    key={item.label}
                    to={item.to!}
                    className="text-sm text-navy/50 hover:text-anchor transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                )
              )}
            </nav>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[13px] font-semibold text-navy mb-5 tracking-wide uppercase">
              <a href="#" className="cursor-pointer">Get in Touch</a>
            </h4>
            <a
              href="mailto:contact@skysailsai.com"
              className="text-sm text-navy/50 hover:text-anchor transition-colors cursor-pointer block mb-3"
            >
              contact@skysailsai.com
            </a>
            <p className="text-sm text-navy/50 font-light">
              Strategy calls available Monday – Friday
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-navy/8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[13px] text-navy/40">
            &copy; 2025 SkySails AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
